<div class="table_field_show">
    <div class="list_show_title">{{ $t('listShow') }}</div>
    <div class="mdc-form-field">
        <template v-for="(value, index) in showTableFieldKeys" :key="index">
            <div class="mdc-checkbox">
                <input type="checkbox" class="mdc-checkbox__native-control" :checked="value.isShow"
                    :id="'checkbox-'+index" @change="$emit('showtablefield', index)" />
                <div class="mdc-checkbox__background">
                    <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                        <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59" />
                    </svg>
                    <div class="mdc-checkbox__mixedmark"></div>
                </div>
                <div class="mdc-checkbox__ripple"></div>
            </div>
            <label v-bind:for="'checkbox-'+index" class="list_show_field">{{value.text}}</label>
        </template>
    </div>
</div>